import { maxLength } from '@reliance/forms-js/lib/validation';
import { ItdsMode } from '@reliance/types/enums/ItdsMode';
import { Facility } from '@reliance/types/models/Facility';
import { FORM_ERROR } from 'final-form';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Form } from 'react-final-form';
import { alertStore } from '../alert/alertStore';
import api from '../common/api';
import { useUser } from '../contexts/UserContext';
import { TextInput } from '../form/TextInput';

type EditTrustAccountsProps = {
  facility: Facility;
  onSave(): any;
  onMigrateToFull(): any;
};

const EditTrustAccounts: React.FC<EditTrustAccountsProps> = (props) => {
  const user = useUser();

  const initialValues = {
    itdsSiteId: props.facility.itdsSiteId,
    itdsVendorId: props.facility.itdsVendorId,
    itdsVendorLogin: props.facility.itdsVendorLogin,
    itdsVendorPassword: props.facility.itdsVendorPassword,
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(formData) =>
        api.put(`/facility/${props.facility.id}`, formData)
          .then(() => alertStore.success('Facility was successfully saved'))
          .then(() => localStorage.removeItem('cachedFacilities'))
          .then(props.onSave)
          .catch((err) => ({ [FORM_ERROR]: err }))
      }
      render={(form) =>
        <form onSubmit={form.handleSubmit}>
          <Card>
            <Card.Body>
              {user.hasPermission('itds_migrate') && props.facility.itdsMode != ItdsMode.FULL &&
                <Button variant="warning" className="mb-3" onClick={props.onMigrateToFull}>
                  Migrate to Wallet
                </Button>
              }

              <Row>
                <Col>
                  <TextInput
                    label="Site ID"
                    validationRules={[maxLength(50)]}
                    name="itdsSiteId" />
                </Col>
                <Col>
                  <TextInput
                    label="Vendor ID"
                    validationRules={[maxLength(50)]}
                    name="itdsVendorId" />
                </Col>
                <Col>
                  <TextInput
                    label="Vendor Login"
                    validationRules={[maxLength(50)]}
                    name="itdsVendorLogin" />
                </Col>
                <Col>
                  <TextInput
                    label="Vendor Password"
                    validationRules={[maxLength(50)]}
                    name="itdsVendorPassword" />
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer>
              <Button
                variant="primary"
                disabled={form.submitting || form.hasValidationErrors}
                type="submit">
                Save
              </Button>
            </Card.Footer>
          </Card>
        </form>
      } />
  );
};

export default EditTrustAccounts;
